import { CqsDto } from "@/lib/cqs";
import { SubTaskStatus } from "@/modules/setup/setupwizard";

interface Dictionary<T> {
    [Key: string]: T;
}

export class SignUpToStoriesOnBoard extends CqsDto {

    public static CqsDtoType = "SignUpToStoriesOnBoard";

    constructor(
        public trelloApiToken: string,
        public trelloUserId: string,
        public trelloEmail: string,
        public trelloFullName: string,
        public trelloInitals: string,
        public trelloUserName: string,
        public password: string,
        public storymapname: string,
        public isSubscribedToNewsletter: boolean,
        public needsHelpWith: string
    ) {
        super();
    }
}

export class CreateSubscriptionFromTrelloLocale extends CqsDto {

    public static CqsDtoType = "CreateSubscriptionFromTrelloLocale";

    constructor(
        public trelloUserId: string,
        public trelloEmail: string,
        public trelloFullName: string,
        public trelloInitals: string,
        public trelloUserName: string,
        public name: string,
        public email: string,
        public storymapName: string,
        public password: string,
        public isSubscribedToNewsletter: boolean,
        public needsHelpWith: string,
        public trelloApiToken: string,
        public epicNames: string[],
        public listsToImport: TrelloList[],
        public currentReleaseName: string,
        public currentReleaseDescription: string,
        public currentReleaseDeadline: string,
        public nextReleaseName: string,
        public statusMap: Dictionary<SubTaskStatus>,
        public exportingList: TrelloList,
        public personalAccessToken: string,
        public externalProjectId: string,
    ) {
        super();
    }
}

export interface TrelloList {
    Id : string;
    Name : string;
}

export class SetupOnExistingIntegration extends CqsDto {

    public static CqsDtoType = "SetupOnExistingIntegration";

    constructor(
        public integrationIdentifier: string,
        public personaAcccessToken: string
        ) { super(); }
}

export class SetPersonalAccessToken extends CqsDto {

    public static CqsDtoType = "SetPersonalAccessToken";

    constructor(public pat: string) {super();}
}

export class UpdateSetup extends CqsDto {

    public static CqsDtoType = "UpdateSetup";

    constructor (
        public isShowEstimation: boolean,
        public isShowEstimationOnCardFront: boolean,
        public isShowEstimationOnCardBack: boolean,

        public isEnableEditEstimation: boolean,
        public storyPointScale: string,
        public isStoryPointScaleValueCustomizable: boolean,
        public isMarkBigStoryCards: boolean,
        public bigStoryLimit: string,

        public isShowStoryAttachemtns: boolean,

        public isShowReleases: boolean,
        public isShowReleasesOnCardFront: boolean,
        public isShowReleasesOnCardBack: boolean,

        public isShowCardContext: boolean,
        public isShowCardContextGoalOnCardFront: boolean,
        public isShowCardContextStepOnCardFront: boolean,
        public isShowCardContextOnCardBack: boolean,

        public isShowAnnotations: boolean,
        public isShowAnnotationsOnCardFront: boolean,
        public isShowAnnotationsOnCardBack: boolean,
        public selectedAnnotations: string[]
    ) {super();}
}


export class DisablePowerUp extends CqsDto {
    public static CqsDtoType = "DisablePowerUp";
}

export class ExportTrelloCardsToStorymap extends CqsDto {

    public static CqsDtoType = "ExportTrelloCardsToStorymap";

}

export class RequestAccessToStorymap extends CqsDto {

    public static CqsDtoType = "RequestAccessToStorymap";

    constructor(
        public integrationIdentifier: string,
        public trelloUserName: string,
        public trelloUserEmail: string
    ) {
        super();
    }
}

export class SetEstimationFromTrello extends CqsDto {

    public static CqsDtoType = "SetEstimationFromTrello";

    constructor(public CardExternalId: string, public Estimation: number) {super();}
}

export class CommonPowerupApiCommandResult {
    constructor(
        public IsSuccess: boolean,
        public Message: string
    ) {

    }
}

export class SignUpToStoriesOnBoardResult extends CommonPowerupApiCommandResult {
    constructor(
        IsSuccess: boolean,
        Message: string,
        public StorymapUrl: string
    ){
        super(IsSuccess, Message);
    }
}
